import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../app-error/app-error.model";
import { TransactionFilter } from "../wallet/wallet.model";

import { AamsTransaction, GameRound, GameRoundFilter } from "./aams-data.model";

export const ACTION_PREFIX = "[AAMS Data]";
export const AAMS_ACTION_TYPE = {
	getLastGameRound: `${ACTION_PREFIX} Get Last Game Round`,
	getLastGameRoundSuccess: `${ACTION_PREFIX} Get Last Game Round Success`,
	getLastGameRoundFail: `${ACTION_PREFIX} Get Last Game Round Fail`,

	getTransactions: `${ACTION_PREFIX} Get Transactions`,
	getTransactionsSuccess: `${ACTION_PREFIX} Get Transactions Success`,
	getTransactionsFail: `${ACTION_PREFIX} Get Transactions Fail`,

	getSessions: `${ACTION_PREFIX} Get Sessions`,
	getSessionsSuccess: `${ACTION_PREFIX} Get Sessions Success`,
	getSessionsFail: `${ACTION_PREFIX} Get Sessions Fail`,

	clearTransactions: `${ACTION_PREFIX} Clear Transactions ${SYNC_SUFFIX}`,
};

export const DEFAULT_TRANSACTIONTOTALS_ID = "DefaultTransactionTotals";

@Injectable({
	providedIn: "root",
})
export class AamsDataAction {
	getLastGameRound(filter: GameRoundFilter): ActionWithPayload {
		return {
			type: AAMS_ACTION_TYPE.getLastGameRound,
			payload: filter,
		};
	}

	getLastGameRoundSuccess(gameRound: GameRound): ActionWithPayload {
		return {
			type: AAMS_ACTION_TYPE.getLastGameRoundSuccess,
			payload: gameRound,
		};
	}

	getLastGameRoundFail(response: AppError): ActionWithPayload {
		return {
			type: AAMS_ACTION_TYPE.getLastGameRoundFail,
			payload: response,
		};
	}

	getTransactions(filter: TransactionFilter): ActionWithPayload {
		return {
			type: AAMS_ACTION_TYPE.getTransactions,
			payload: filter,
		};
	}

	getTransactionsSuccess(transaction: AamsTransaction): ActionWithPayload {
		return {
			type: AAMS_ACTION_TYPE.getTransactionsSuccess,
			payload: transaction,
		};
	}

	getTransactionsFail(response: AppError): ActionWithPayload {
		return {
			type: AAMS_ACTION_TYPE.getTransactionsFail,
			payload: response,
		};
	}

	getSessions(filter: TransactionFilter): ActionWithPayload {
		return {
			type: AAMS_ACTION_TYPE.getSessions,
			payload: filter,
		};
	}

	getSessionsSuccess(transaction: AamsTransaction): ActionWithPayload {
		return {
			type: AAMS_ACTION_TYPE.getSessionsSuccess,
			payload: transaction,
		};
	}

	getSessionsFail(response: AppError): ActionWithPayload {
		return {
			type: AAMS_ACTION_TYPE.getSessionsFail,
			payload: response,
		};
	}

	clearTransactions(): Action {
		return {
			type: AAMS_ACTION_TYPE.clearTransactions,
		};
	}
}
